import { ComponentRef, Directive, inject, Input, OnInit } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { takeUntil } from 'rxjs/operators';
import { GroupsListContextMenuComponent } from '../components/groups-list-context-menu/groups-list-context-menu.component';
import { GroupListStateService } from '../services/group-list-state.service';

@Directive({
  selector: '[appGroupsListContextMenu]',
  standalone: false,
})
export class GroupsListContextMenuDirective extends ContextMenuDirective implements OnInit {
  @Input() appGroupsListContextMenuWithAdvancedSearch: boolean;
  @Input() appGroupsListContextMenuWithScore: boolean;
  @Input() stchPopoverTrigger: PopoverTrigger = 'click';
  @Input() stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly groupListStateService = inject(GroupListStateService);

  protected override registerInstance(componentRef: ComponentRef<GroupsListContextMenuComponent>) {
    componentRef.instance.state = this.groupListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appGroupsListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appGroupsListContextMenuWithScore;
  }

  protected override registerComponent() {
    return GroupsListContextMenuComponent;
  }

  public override ngOnInit() {
    super.ngOnInit();

    this.groupListStateService
      .value()
      .pipe(takeUntil(this.alive))
      .subscribe((listState) => {
        this.isDefaultStateObservable?.next(listState.isDefault());
      });

    if (!this.isDefaultStateObservable) {
      return;
    }

    this.isDefaultStateObservable.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.groupListStateService.state.isDefault()) {
        this.groupListStateService.state.resetToDefault();
      }
    });
  }
}
